/*
 * Kanzi — Variant Media Filter  (v2, tested on the live preview)
 * ------------------------------------------------------------------
 * Pick a colour → the gallery shows ONLY that colour's photos.
 * Swipe, arrows and thumbnails all respect it.
 *
 * HOW IT KNOWS: each colour variant already has a featured image in
 * admin. Those positions mark where each colour's photo group starts,
 * so the group runs until the next colour's featured image. Nothing
 * for the merchant to maintain — no alt text, no metafields.
 *
 * SAFE BY DESIGN:
 *  - scoped strictly to <media-gallery> (never touches the
 *    announcement bar or any other slideshow on the page)
 *  - if a product has no colour option, or colours have no featured
 *    images, it does nothing and every photo shows as before
 *  - unrecognised media is always kept visible
 */
(function () {
  var cache = null;

  function readMap() {
    if (cache) return Promise.resolve(cache);
    var el = document.getElementById('kanzi-vm-map');
    if (el) {
      try {
        var raw = JSON.parse(el.textContent);
        cache = build(raw);
        return Promise.resolve(cache);
      } catch (e) { /* fall through to fetch */ }
    }
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    return fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var ci = -1;
        (p.options || []).forEach(function (o, i) {
          var name = (typeof o === 'string' ? o : o.name) || '';
          if (/colou?r|لون/i.test(name)) ci = i;
        });
        if (ci < 0) return null;
        var variants = {}, starts = [], media = {}, seen = {};
        p.variants.forEach(function (v) {
          var c = v.options[ci];
          variants[String(v.id)] = c;
          if (!seen[c] && v.featured_media) {
            seen[c] = 1;
            starts.push({ c: c, start: v.featured_media.position });
          }
        });
        p.media.forEach(function (mm) { media[String(mm.id)] = mm.position; });
        cache = build({ count: p.media.length, variants: variants, starts: starts, media: media });
        return cache;
      })
      .catch(function () { return null; });
  }

  function build(raw) {
    if (!raw || !raw.starts || raw.starts.length < 2) return null;
    var bands = raw.starts.slice().sort(function (a, b) { return a.start - b.start; });
    bands.forEach(function (b, i) {
      b.end = i + 1 < bands.length ? bands[i + 1].start - 1 : raw.count;
    });
    raw.bands = bands;
    return raw;
  }

  function selectedColour(map) {
    // 1. URL (most reliable — updates on every variant change)
    var u = new URLSearchParams(location.search).get('variant');
    if (u && map.variants[u]) return map.variants[u];
    // 2. the product form's hidden variant input
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && map.variants[String(input.value)]) return map.variants[String(input.value)];
    // 3. a checked radio whose value is one of our colours
    var hit = null;
    document.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (!hit && map.bands.some(function (b) { return b.c === r.value; })) hit = r.value;
    });
    // 4. nothing chosen yet → behave as if the FIRST colour is selected,
    //    so the gallery is never a mixed bag of every colour on arrival.
    return hit || (map.bands[0] && map.bands[0].c);
  }

  var lastColour = null; // only jump back to slide 1 when the colour truly changes

  function apply() {
    readMap().then(function (map) {
      if (!map) return;
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      var colour = selectedColour(map);
      var band = map.bands.filter(function (b) { return b.c === colour; })[0];

      gallery.querySelectorAll('slideshow-slide, .media-gallery__grid > li').forEach(function (slide) {
        var holder = slide.matches('[data-media-id]') ? slide : slide.querySelector('[data-media-id]');
        var id = holder && holder.getAttribute('data-media-id');
        var pos = map.media[String(id)];

        // unknown media, or no band resolved → always show
        if (!pos || !band) {
          slide.removeAttribute('hidden');
          slide.style.removeProperty('display');
          return;
        }
        if (pos >= band.start && pos <= band.end) {
          slide.removeAttribute('hidden');
          slide.style.removeProperty('display');
        } else {
          slide.setAttribute('hidden', '');
          if (!slide.matches('slideshow-slide')) slide.style.display = 'none';
        }
      });

      // Only jump to the first photo when the shopper actually switched
      // colour. Doing it on every re-render fights their swiping and
      // snaps the gallery back to image 1.
      if (band && colour !== lastColour) {
        lastColour = colour;
        var show = gallery.querySelector('slideshow-component') || gallery;
        try { if (typeof show.select === 'function') show.select(0); } catch (e) { /* non-fatal */ }
      }
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(apply, 80); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // the theme re-renders the gallery on variant change — re-apply after it
  document.addEventListener('variant:update', schedule);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') schedule();
  }, true);
  window.addEventListener('popstate', schedule);

  var gal = document.querySelector('media-gallery');
  if (gal && window.MutationObserver) {
    new MutationObserver(function (muts) {
      // ignore our own hidden-attribute writes
      var real = muts.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length;
      });
      if (real) schedule();
    }).observe(gal, { childList: true, subtree: true });
  }
})();
